import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const CenterLayoutContainer = styled.div<{ backgroundColor: string }>`
  height: 100%;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.Colors.Background.White};
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 1fr 8fr 1fr;
  grid-template-areas:
    '. logo logo logo logo logo logo logo logo logo logo .'
    '. main main main main main main main main main main .'
    '. . . . . . . . . . . .';

  @media ${breakpoints.s} {
    background-color: ${({ backgroundColor }) => backgroundColor};
    grid-template-areas:
      '. logo logo logo logo logo logo logo logo logo logo .'
      '. . main main main main main main main main . .'
      '. . . . . . . . . . . .';
  }
`

const CenterLayoutLogo = styled.div`
  margin: 32px 0;
  max-height: 60px;
  grid-area: logo;
`

const CenterLayoutContent = styled.main`
  grid-area: main;
`

export { CenterLayoutContainer, CenterLayoutContent, CenterLayoutLogo }
